var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FillClaimCreationSection',{attrs:{"FC":_vm.FC,"createData":_vm.createData,"adminOptions":_vm.adminOptions},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }